import { ComboBox } from "@fluidattacks/design";
import type { IComboBoxProps, IItem } from "@fluidattacks/design";
import { useEffect, useState } from "react";

import type { ICountry } from "utils/countries";
import { getCountries } from "utils/countries";

const CountriesSelect = ({
  onChange,
  countryValue,
}: Readonly<
  Partial<IComboBoxProps> & { countryValue: string }
>): JSX.Element => {
  const [countries, setCountries] = useState<ICountry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect((): void => {
    const loadCountries = async (): Promise<void> => {
      setLoading(true);
      setCountries(await getCountries());
      setLoading(false);
    };
    void loadCountries();
  }, []);

  const countryOptions = countries.map(
    (country): IItem => ({ name: country.name, value: country.name }),
  );

  if (loading) {
    return <div>{"Loading countries..."}</div>;
  }

  return (
    <ComboBox
      items={countryOptions}
      label={"Country where the organization is based"}
      name={"country"}
      onChange={onChange}
      required={true}
      value={countryValue}
    />
  );
};

export { CountriesSelect };
